<template>
  <div
    v-if="display()"
    :class="$route.meta.titleColor ? ' ' + $route.meta.titleColor : ''"
    class="title"
  >
    <span class="e-aixam -title" v-html="getTitle()"></span>
  </div>
</template>

<script>
import { vehicleManager } from "@/services/vehicle-manager";
import { mapState } from "pinia";
import { useMainStore } from "@/store";
import { getTranslation } from "@/services/translation-manager";

export default {
  name: "PageTitleComponent",
  props: {
    title: {
      type: String,
      required: false,
      defaut: null,
    },
  },
  computed: {
    ...mapState(useMainStore, {
      translations: (store) => store.translations,
      locale: (store) => store.locale,
    }),
  },
  methods: {
    display() {
      return !["Home", "Gallery"].includes(this.$route.name);
    },

    getTitle() {
      return this.processVehicleLabel();
    },

    processVehicleLabel() {
      return vehicleManager.processLabel(
        this.title
          ? this.title
          : typeof this.$route.meta.title === "number"
            ? this.getTranslation(this.$route.meta.title)
            : this.$route.meta.title,
      );
    },

    getTranslation(id) {
      return getTranslation(id);
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  position: fixed;
  top: 0;
  left: 0;
  padding: 10px 75px;
  font-size: 35px;
  color: $blue;
  z-index: 1000;

  &.blue {
    color: $white;

    &:before {
      background: $blue;
    }
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: -50%;
    background: $white;
    width: 150%;
    height: 100%;
    transform: skewX($skew);
    z-index: -1;
  }
}
</style>
